/**
 * 「网关托管能力」的协议 id 与端点路径 —— DOSIA 侧的**唯一真相源**（接缝 R 锚点）。
 *
 * 这两条腿（联网搜索 tavily / 音频转写 volc_asr）的凭证不再是厂商密钥直存本机，而是
 * 走与其余 hosted 腿完全同律的一条路：超管在「工具模型策展」填一个 **gateway 组名** →
 * 网关随 bundle 下发一条**伪模型行**（`protocol` 见下表）→ 客户端按 `(protocol, group)`
 * 解出组凭证 → 打网关代理端点。
 *
 * 为什么协议 id 与路径必须收在**一处**：它们同时被三个面消费——
 *  · `model-registry` 的 `applyModelSelection`（伪模型行必须绕过 `toolModels` 白名单，
 *    否则 org 一配白名单这两条腿就静默消失）；
 *  · desktop `resolveGroupProtocolEndpoint`（按 `protocol` 在 catalog 里挑行）；
 *  · core 的两个工具 handler（按 `endpointPath` 拼请求 URL）。
 * 三处各抄一份的漂移表现恰好是最难查的那种：**策展配了、客户端说未配置**，且零报错。
 *
 * 网关侧的对应事实（跨仓契约，接缝 R）：`tavily-search` / `volc-bigasr-auc-turbo` 两条
 * 伪模型行的 `endpoint_path` 与本表逐字相等。**本表不复述网关的模型 id**——那是网关下发
 * 的运行时事实（`modelId` 从 bundle 行现取），写死在这里就是一份会过期的副本（红线 #9）。
 */
/** 策展 provider id → 网关协议契约。 */
export const GATEWAY_CAPABILITY_PROTOCOLS = {
    tavily: { protocol: "tavily_search", endpointPath: "/v1/search" },
    volc_asr: {
        protocol: "openai_audio_transcriptions",
        endpointPath: "/v1/audio/transcriptions",
    },
};
/** 全部网关托管能力协议 id（供白名单放行判据用）。 */
const GATEWAY_CAPABILITY_PROTOCOL_IDS = Object.values(GATEWAY_CAPABILITY_PROTOCOLS).map((c) => c.protocol);
/**
 * 这个 catalog 行的 `protocol` 是不是一条网关托管能力腿。
 *
 * 唯一消费点是模型漏斗的**放行**判据：伪模型行不是主脑候选、也不该被 org 的
 * `modelSelection.toolModels` 白名单裁掉——白名单是给「模型」用的，而这两行是**能力
 * 通道**，被裁掉的表现是「超管配了组、员工端这两个工具永远不注册」。
 */
export function isGatewayCapabilityProtocol(p) {
    return typeof p === "string" && GATEWAY_CAPABILITY_PROTOCOL_IDS.includes(p);
}
//# sourceMappingURL=gateway-capability-protocols.js.map